import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { PageTechnicalDetailsDrawerComponent } from './page-technical-details-drawer.component';

@Component({
  selector: 'app-technical-audits-page',
  templateUrl: './technical-audits-page.component.html',
  styleUrls: ['./technical-audits-page.component.css'],
})
export class TechnicalAuditsPageComponent implements OnInit {
  data: any = null;
  worstPages: any[] = [];
  loading = true;
  url = 'seoTechnicalAudits';

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadDashboard();
    this.loadWorstPages();
  }

  loadDashboard() {
    this.dataService.getData(this.url).subscribe((res) => {
      if (res.rst) {
        this.data = res.data;
      }
    });
  }

  loadWorstPages() {
    this.dataService.getData(this.url + '/worst').subscribe((res) => {
      if (res.rst) {
        this.worstPages = res.data;
      }
      this.loading = false;
    });
  }

  openDetails(audit: any) {
    const dialogRef = this.dialog.open(PageTechnicalDetailsDrawerComponent, {
      width: '600px',
      position: { right: '0' },
      height: '100vh',
      panelClass: 'side-drawer',
      data: { audit },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadDashboard();
        this.loadWorstPages();
      }
    });
  }

  onAuditSelected(audit: any) {
    this.openDetails(audit);
  }
}
